import {
  useMemo,
  useSyncExternalStore,
} from 'react';

import {
  getTreeRuntimeMissingParentLifecycleOperationalRevision,
  readTreeRuntimeMissingParentLifecycleOperationalObservation,
  subscribeTreeRuntimeMissingParentLifecycleOperationalObservation,
  type TreeRuntimeMissingParentLifecycleOperationalSnapshot,
} from '@/governor/tree-runtime/TreeRuntimeMissingParentLifecycleAttributionOperationalObservability';

const getServerRevision =
  (): number => 0;

export const useTreeRuntimeMissingParentLifecycleOperationalObservability =
  (): TreeRuntimeMissingParentLifecycleOperationalSnapshot => {
    const revision =
      useSyncExternalStore(
        subscribeTreeRuntimeMissingParentLifecycleOperationalObservation,
        getTreeRuntimeMissingParentLifecycleOperationalRevision,
        getServerRevision,
      );

    return useMemo(
      () =>
        readTreeRuntimeMissingParentLifecycleOperationalObservation(),
      [revision],
    );
  };
